import { IDescriptionHolding } from '@core/models/interfaces/holding/description-holding.interface';
import { environment } from '@env/environment';

export class HoldingItem {
  title!: string;
  href!: string;
  image!: string;
  class?: string;
  order?: number;

  constructor(value: IDescriptionHolding) {
    Object.assign(this, value);
    this.image = this.getImagePath(value.image);
  }

  getImagePath(imageName: string): string {
    return `${environment.endpoint.assets}${imageName}`;
  }
}
